import React, { useState, createRef, useEffect, useContext } from 'react';
import { signUpContext } from '../../../pages/signup';
import styles from './OTPInput.module.css'
import BlueButton from '../../../components/ui/BlueButton';



const OTPInput = () => {
    const [otp, setOtp] = useState(Array(6).fill(''));
    const otpInputRefs = Array(6).fill().map(() => createRef());
    const { setNext, Mail } = useContext(signUpContext);

    const focusInput = (inputIndex) => {
      if (inputIndex < otpInputRefs.length) {
        otpInputRefs[inputIndex].current.focus();
      }
    };
  
    const handleOTPChange = (e, index) => {
      const { value } = e.target;
      if (/^[0-9]{0,1}$/.test(value)) {
        setOtp((prevOtp) => {
          const newOtp = prevOtp.map((digit, idx) => (idx === index ? value : digit));
          return newOtp;
        });
        if (value.length === 1) {
          focusInput(index + 1);
        }
      }
    };
  
    useEffect(() => {
      otpInputRefs[0].current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Submit Handler
    const handleSubmit = (event) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const otps = [];
      for (let i = 0; i <= 6; i++) {
        otps.push(formData.get(`otp-${i}`));
      }     
      setNext(3);
      alert(`OTP verified succesfully: ${otps.join(', ')}`);
      //validation logic and protected route for details, seperate the fill detail into page..
 
    };
    return (
      <>
        <h1>Email Verification</h1>
        <div className={styles.container0}>
          <form onSubmit={handleSubmit}>
            <div className={styles.container}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  name={`otp-${index}`}
                  value={digit}
                  onChange={(e) => handleOTPChange(e, index)}
                  ref={otpInputRefs[index]}
                  required
                />
              ))}
            </div>
            <div className={styles.resend}>
              <button type="button" onClick={() => {}}>Resend OTP</button>
            </div>
            {true ? (<p style={{fontSize: '1rem'}}>We sent an OTP to {Mail}</p>) : (null)}
            <div className={styles.button}><BlueButton type={'submit'} extraStyle={{width: "50%"}}>Next</BlueButton></div>
            
          </form>
        </div>
      </>
    );
  };

  export default OTPInput;